import { Cnae } from "../gateway/Cnae/Cnae";

export class GetCnaeUsecase {
    constructor() {
        this.CnaeGateway = new Cnae();
    }

    async execute({ term = "" } = {}) {
        const sanitizedTerm = String(term).trim();
        if (!sanitizedTerm) return { cnaes: [], total: 0 };
        const response = await this.CnaeGateway.search(sanitizedTerm);
        const cnaes = Array.isArray(response?.cnaes) ? response.cnaes : [];
        const total =
            typeof response?.total === "number" ? response.total : cnaes.length;
        return { cnaes, total };
    }
}
